import React, { useState } from "react";
import {
  Grid,
  Box,
  makeStyles,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  useMediaQuery,
  useTheme,
  MenuItem,
} from "@material-ui/core";
import { TextField } from "formik-material-ui";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik, Field } from "formik";
import { useHistory } from "react-router-dom";
import BodyText from "../components/reusableComponents/BodyText";
import { fetchForex, HoldSearchDispatch } from "../reducers/HomeReducer";
import { useEffect } from "react";
import { supplierGETDispatch } from "../reducers/UserReducer";
import { setSelectedOrigin } from "../reducers/UiReducer";
import DesktopDateFlight from "../components/reusableComponents/DesktopDateFlight";
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        // border: "1px solid #959595",
      },
    },
    // backgroundColor: 'white',
    // marginBottom: 30,
    width: "100%",
    // border: "1px solid #959595",
    marginTop: 10,
    borderRadius: 5,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 15,
      marginTop: 8,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
    },
    "& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: 5,
    },
    "& .MuiSelect-select": {
      padding: 8,
      border: "1px solid grey",
    },
  },
  InputPropsStyle: {
    // backgroundColor: 'white',
    borderRadius: 15,
  },
  inputPropsStyle: {
    padding: 8,
    // border: "1px solid lightgrey",
  },
  root: {
    "& .MuiFormControl-root": {
      "& div": {
        "& div": {
          display: "none",
        },
      },
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },

    "& input": {
      fontSize: ".8em",
      fontWeight: 600,
      padding: "0px 4px 4px 0px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },

    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-184whfw-MuiAutocomplete-root .MuiAutocomplete-inputRoot":
      {
        paddingRight: 0,
      },
    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-xzqck1-MuiAutocomplete-root .MuiAutocomplete-inputRoot":
      {
        paddingRight: 0,
      },
  },
  radio: {
    "& .MuiRadio-root": {
      color: "grey",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "black",
      fontSize: ".8em",
      [theme.breakpoints.down("xs")]: {
        fontSize: 10,
      },
      // fontSize: '14px',
      //   fontWeight: 800,
    },
  },
  radio2: {
    "& .MuiRadio-root": {
      color: "black",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "black",
      fontSize: ".8em",
      [theme.breakpoints.down("xs")]: {
        fontSize: 10,
      },
      // fontSize: '14px',
      // fontWeight: 800,
    },
  },
  popper: {
    "& .MuiAutocomplete-listbox": {
      "& :hover": {
        color: "rgb(239, 51, 57)",
        // '& img': {
        // 	background: 'rgb(239, 51, 57)',
        // },
      },
    },
  },
}));
const SearchEngineForex = () => {
  const classes = useStyles();
  const history = useHistory();
  const { sector,agentlogin } = useSelector((state) => state.user);
  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);
  const [infant, setInfant] = useState(0);
  const { selectedOrigin } = useSelector((state) => state.ui);
  const { origin } = useSelector((state) => state.ui);
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    let form = {};
    dispatch(supplierGETDispatch(form));
  }, []);
  const [trip, setTrip] = useState("buy");
  const title = [
    "U.S. Dollar",
    "Australian Dollar",
    "Canadian Dollar",
    "Euro",
    "New Zealand Dollar",
    "British Pound",
    "Hong Kong Dollar",
    "Japanese Yen",
    "Kuwaiti Dinar",
    "Malaysian Ringgit",
    "Omani Rial",
    "Qatari Riyal",
    "Saudi Riyal",
    "Singapore Dollar",
    "Thai Baht",
    "UAE Dirham",
  ];
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  let originsector = [];
  let destinationsector = [];
  let destinationsectorUnique = [];
  if (sector?.status === 200 && sector?.result.length > 0) {
    originsector = [
      ...new Set(
        sector &&
          sector?.result &&
          sector?.result.length > 0 &&
          sector?.result.map((item) => item.origin)
      ),
    ];
  }
  if (sector?.status === 200 && sector?.result.length > 0) {
    sector &&
      sector?.result &&
      sector?.result.length > 0 &&
      sector.result.map((i) => {
        if (i.origin === selectedOrigin)
          destinationsector.push({
            ...i,
          });
      });
  }
  if (destinationsector && destinationsector?.length > 0) {
    destinationsectorUnique = [
      ...new Set(
        destinationsector &&
          destinationsector.length > 0 &&
          destinationsector.map((item) => item.destination)
      ),
    ];
  }
  // console.log("sector", sector);
  // console.log("destinationsector", destinationsector);
  // console.log("destinationsectorUnique", destinationsectorUnique);
  const handleSubmit = (data) => {
    let formData = {
      AdultCount: adult,
      ChildCount: child,
      InfantCount: infant,
      DirectFlight: false,
      OneStopFlight: false,
      JourneyType: 1,
      PreferredAirlines: null,
      Segments: [
        {
          Origin: data.origin,
          Destination: data.destination,
          FlightCabinClass: 1,
          PreferredDepartureTime: origin,
        },
      ],
      Sources: "WEB",
      agent_id: agentlogin
        ? agentlogin.status === 200
          ? agentlogin?.result.result.id
          : 0
        : 0,
    };
    console.log('data',formData)
    history.push({
      pathname: "/search",
      state: {
        body: formData,
        OriginO: origin,
      },
    });
    // let formData = {
    //   forex_type: trip,
    //   amount: data.amount,
    //   email: data.email,
    //   mobile: data.mobile,
    //   name: data.name,
    //   type: data.type,
    // };
    // dispatch(fetchForex(formData, history));
    // dispatch(HoldSearchDispatch(formData))
  };
  const handleChangeTrip = (e) => {
    setTrip(e.target.value);
  };
  return (
    <>
            <Formik
              initialValues={{
              }}
              validate={(values) => {
                const errors = {};
              }}
              onSubmit={handleSubmit}
            >
              {({ submitForm, isSubmitting, setFieldValue, values }) => (
                <>
                  <Form
                    style={{
                      background: "white",
                      marginTop: "10px",
                      paddingLeft: 20,
                      paddingRight: 20,
                      boxShadow: "-1px 3px 5px 0 rgb(0 0 0 / 16%)",
                    }}
                  >
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={12} lg={6}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid
                            item
                            xs={12}
                            lg={6}
                            style={{
                              // display: "flex",
                              // alignItems: "center",
                              marginTop: 23,
                            }}
                          >
                            <Box justifyContent="space-between">
                              <span
                                style={{
                                  color: "black",
                                  fontSize: matches ? 12 : ".8em",
                                }}
                              >
                                Leaving From
                              </span>
                              <Field
                                component={TextField}
                                select
                                name="origin"
                                type="text"
                                variant="outlined"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {originsector.map((item, index) => (
                                  <MenuItem
                                    onClick={() =>
                                      dispatch(setSelectedOrigin(item))
                                    }
                                    key={index}
                                    value={item}
                                    style={{ padding: 5 }}
                                  >
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Box>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            lg={6}
                            style={{
                              // display: "flex",
                              alignItems: "center",
                              marginTop: 23,
                            }}
                          >
                            <Box justifyContent="space-between">
                              <span
                                style={{
                                  color: "black",
                                  fontSize: matches ? 12 : ".8em",
                                }}
                              >
                                Going TO
                              </span>

                              <Field
                                component={TextField}
                                select
                                name="destination"
                                type="text"
                                variant="outlined"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {destinationsectorUnique.map((item, index) => (
                                  <MenuItem
                                    key={index}
                                    value={item}
                                    style={{ padding: 5 }}
                                  >
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={12} lg={2}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          style={{ marginTop: 20 }}
                        >
                          <span
                            style={{
                              color: "black",
                              fontSize: matches ? 12 : ".8em",
                              marginBottom: 4,
                            }}
                          >
                            Depart Date
                          </span>
                        </Box>
                        <DesktopDateFlight />
                      </Grid>

                      <Grid item xs={12} md={12} lg={4}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid
                            item
                            xs={12}
                            lg={6}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: 20,
                            }}
                          >
                            <ul
                              class="menu"
                              style={{
                                marginTop: 20,
                                borderRadius: 2,
                                paddingLeft: 0,
                                cursor: "pointer",
                                width: "100%",
                                // width: trip == "roundtrip" ? "110%" : "95%",
                              }}
                            >
                              <li>
                                <div
                                  onClick={() =>
                                    toggle ? setToggle(false) : setToggle(true)
                                  }
                                  style={{
                                    padding: 8,
                                    fontSize: matches ? 12 : ".9em",
                                    borderRadius: 4,
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    fontWeight: 600,
                                    border: "1px solid lightgrey",
                                    textAlign: "center",
                                  }}
                                >
                                  Travellers,Classes
                                </div>

                                {toggle ? (
                                  <>
                                    {" "}
                                    <ul
                                      style={{
                                        padding: 5,
                                        height: 170,
                                        width: 200,
                                      }}
                                    >
                                      <li>
                                        <Box
                                          style={{ padding: 5 }}
                                          display="flex"
                                          justifyContent="space-between"
                                          textAlign="center"
                                          alignItems="center"
                                        >
                                          <BodyText
                                            four
                                            textStyle={{
                                              color: "black",
                                              fontSize: 16,
                                              fontWeight: 500,
                                            }}
                                          >
                                            Adult
                                          </BodyText>
                                          <Box
                                            display="flex"
                                            alignItems="center"
                                          >
                                            <Box
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                              onClick={() =>
                                                adult === 0
                                                  ? ""
                                                  : setAdult(adult - 1)
                                              }
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                -
                                              </BodyText>
                                            </Box>
                                            <Box
                                              ml={"15px"}
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                {adult}
                                              </BodyText>
                                            </Box>
                                            <Box
                                              ml={"15px"}
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                              onClick={() =>
                                                adult + child + infant === 9
                                                  ? adult
                                                  : setAdult(adult + 1)
                                              }
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                +
                                              </BodyText>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </li>
                                      <li>
                                        <Box
                                          style={{ padding: 5 }}
                                          display="flex"
                                          justifyContent="space-between"
                                          textAlign="center"
                                          alignItems="center"
                                        >
                                          <BodyText
                                            four
                                            textStyle={{
                                              color: "black",
                                              fontSize: 16,
                                              fontWeight: 500,
                                            }}
                                          >
                                            Child
                                          </BodyText>
                                          <Box
                                            display="flex"
                                            alignItems="center"
                                          >
                                            <Box
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                              onClick={() =>
                                                child === 0
                                                  ? ""
                                                  : setChild(child - 1)
                                              }
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                -
                                              </BodyText>
                                            </Box>
                                            <Box
                                              ml={"15px"}
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                {child}
                                              </BodyText>
                                            </Box>
                                            <Box
                                              ml={"15px"}
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                              onClick={() =>
                                                adult + child + infant === 9
                                                  ? child
                                                  : setChild(child + 1)
                                              }
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                +
                                              </BodyText>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </li>
                                      <li>
                                        <Box
                                          style={{ padding: 5 }}
                                          display="flex"
                                          justifyContent="space-between"
                                          textAlign="center"
                                          alignItems="center"
                                        >
                                          <BodyText
                                            four
                                            textStyle={{
                                              color: "black",
                                              fontSize: 16,
                                              fontWeight: 500,
                                            }}
                                          >
                                            Infant
                                          </BodyText>
                                          <Box
                                            display="flex"
                                            alignItems="center"
                                          >
                                            <Box
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                              onClick={() =>
                                                infant === 0
                                                  ? ""
                                                  : setInfant(infant - 1)
                                              }
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                -
                                              </BodyText>
                                            </Box>
                                            <Box
                                              ml={"15px"}
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                {infant}
                                              </BodyText>
                                            </Box>
                                            <Box
                                              ml={"15px"}
                                              style={{
                                                cursor: "pointer",
                                                background: "rgb(0, 55, 114)",
                                                padding: "0px 10px",
                                                borderRadius: "5px",
                                              }}
                                              onClick={() =>
                                                adult + child + infant === 9
                                                  ? infant
                                                  : setInfant(infant + 1)
                                              }
                                            >
                                              <BodyText
                                                textStyle={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              >
                                                +
                                              </BodyText>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </li>
                                      <li>
                                        <Box
                                          style={{ padding: 10 }}
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="space-between"
                                        >
                                          <Box className={classes.radio2}></Box>
                                          <Box
                                            style={{
                                              background: "darkcyan",
                                              padding: 5,
                                            }}
                                            onClick={() => setToggle(false)}
                                          >
                                            <span
                                              style={{
                                                color: "white",
                                                cursor: "pointer",
                                                fontSize: 12,
                                              }}
                                            >
                                              Done
                                            </span>
                                          </Box>
                                        </Box>
                                      </li>
                                      {/* <li></li> */}
                                    </ul>
                                  </>
                                ) : (
                                  ""
                                )}
                              </li>
                            </ul>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            lg={6}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: 5,
                            }}
                          >
                            <Box
                              onClick={submitForm}
                              className="btn"
                              style={{
                                width: "100%",
                                fontSize: "16px",
                                borderRadius: 4,
                                backgroundColor: "rgb(0, 55, 114)",
                                padding: 6,
                                textAlign: "center",
                                marginTop: 36,
                              }}
                            >
                              <span>Submit</span>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Form>
                </>
              )}
            </Formik>
          </>
  );
};

export default SearchEngineForex;
